export enum EPersonalDetailsFormSteps {
  identityProvider = 'identityProvider',
  personalInfo = 'personalInfo',
  extraPersonalInfo = 'extraPersonalInfo',
}
